/*jshint strict: false */
(
    /**
     * @param  {Window} window
     * @param  {Document} document
     * @param  {jQuery} $
     * @param  {lodash} _
     * @param undefined
     */
    function (window, document, $, _, undefined) {
        var token = $('meta[name="csrf-token"]').attr('content');

        /**
         *
         * @param {string} url
         * @param {object} data
         * @param {function} doneHandler
         * @param {function} failHandler
         */
        function doAjaxValidation(url, data, doneHandler, failHandler) {
            var options = {
                url: url,
                method: 'POST',
                dataType: 'json',
                data: data,
                async: false,
                success: doneHandler,
                error: failHandler
            };

            $.ajax(options);
        }

        // unique email
        $.validator.addMethod( "uniqueEmail", function( value, element, param ) {
            var isValid = false,
                data = {
                    _token: token,
                    email: $(element).val()
                },
                doneHandler = function (data) {
                    isValid = data;
                },
                failHandler = function () {
                    isValid = false;
                };

            if (_.isInteger(param)) {
                data.ignore = param;
            }

            doAjaxValidation(window.validationUrls.uniqueEmail, data, doneHandler, failHandler);

            return this.optional(element) || isValid;
        }, "The email address is already in use." );

        // check industry
        $.validator.addMethod( "checkIndustry", function(value, element) {
            var isValid = false,
                data = {
                    _token: token,
                    industry: _.parseInt($(element).val())
                },
                doneHandler = function (data) {
                    isValid = data;
                },
                failHandler = function () {
                    isValid = false;
                };

            doAjaxValidation(window.validationUrls.checkIndustry, data, doneHandler, failHandler);

            return this.optional(element) || isValid;
        }, "The please choose a valid Industry." );

        // check segment
        $.validator.addMethod( "checkSegment", function(value, element) {
            var isValid = false,
                data = {
                    _token: token,
                    segment: _.parseInt($(element).val()),
                    industry: $('#industry').val()
                },
                doneHandler = function (data) {
                    isValid = data;
                },
                failHandler = function () {
                    isValid = false;
                };

            doAjaxValidation(window.validationUrls.checkSegment, data, doneHandler, failHandler);

            return this.optional(element) || isValid;
        }, "The please choose a valid Segment." );

        // check segment
        $.validator.addMethod( "checkRegion", function(value, element) {
            var isValid = false,
                data = {
                    _token: token,
                    region: _.parseInt($(element).val()),
                    country: $('#country').val()
                },
                doneHandler = function (data) {
                    isValid = data;
                },
                failHandler = function () {
                    isValid = false;
                };

            doAjaxValidation(window.validationUrls.checkRegion, data, doneHandler, failHandler);

            return this.optional(element) || isValid;
        }, "The please choose a valid Region." );

        // check country
        $.validator.addMethod( "checkCountry", function(value, element) {
            var isValid = false,
                data = {
                    _token: token,
                    country: _.parseInt($(element).val())
                },
                doneHandler = function (data) {
                    isValid = data;
                },
                failHandler = function () {
                    isValid = false;
                };

            doAjaxValidation(window.validationUrls.checkCountry, data, doneHandler, failHandler);

            return this.optional(element) || isValid;
        }, "The please choose a valid Country." );

        // check country
        $.validator.addMethod( "checkRole", function(value, element) {
            var isValid = false,
                selectedOption = $(element).find('option:selected'),
                data = {
                    _token: token,
                    role: $(element).val(),
                    country: selectedOption.data('country'),
                    market: selectedOption.data('market')
                },
                doneHandler = function (data) {
                    isValid = data;
                },
                failHandler = function () {
                    isValid = false;
                };

            doAjaxValidation(window.validationUrls.checkRole, data, doneHandler, failHandler);

            return this.optional(element) || isValid;
        }, "The please choose a valid Role." );
    }
)(window, document, window.jQuery, window._);
